<template>
  <div class="print-previous-replies">
    <printing-page>
      <papers-header :title="`سجل طلب`">
        <h3 v-if="request.courtName">
          {{ request.courtName }}
        </h3>
        <h3 v-if="request.status" />
      </papers-header>

      <paper v-if="request.objectKey">
        <request-info :requires-verification="false"></request-info>
        <previous-replies></previous-replies>
      </paper>

      <action></action>
    </printing-page>

    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import RequestInfo from '../components/request-info/index';
import PreviousReplies from '../components/request-records-modal/previous-replies';
import PrintingPage from '@/components/printing/page.vue';
import Paper from '@/components/printing/paper.vue';
import PapersHeader from '@/components/printing/header.vue';
import Action from '@/components/printing/action.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  components: {
    RequestInfo,
    PreviousReplies,
    PrintingPage,
    Paper,
    PapersHeader,
    Action,
  },
  created () {
    if (this.requestObjectKey) {
      let actionMethod = 'openLawsuitPreviousReplies';
      if (this.$route.query.courts) {
        actionMethod = 'openCaseRelatedPreviousReplies';
      }
      this[actionMethod](this.requestObjectKey).then(() => {
        document.querySelector(`#previous-replies-table tbody td.text-center > i`).click();
        if (this.doPrint) {
          setTimeout(() => {
            window.focus();
            window.print();
            setTimeout(() => {
              window.close();
            }, 200);
          }, 500);
        }
      });
    }
  },
  computed: {
    ...mapState({ request: state => state.submittedRequestInfo }),
    requestObjectKey () {
      return this.$route.params.objectKey;
    },
    doPrint () {
      return !!this.$route.query.print;
    },
  },
  methods: { ...mapActions(['openLawsuitPreviousReplies', 'openCaseRelatedPreviousReplies']) },
};
</script>
